import { css } from "@emotion/react";
import type { FC } from "react";
import GBtn from "./GBtn";

type Props = React.ComponentProps<typeof GBtn> & {
  skewBg?: string;
};

export const GBtnSkewFill: FC<Props> = (props) => {
  const { skewBg, ...rest } = props;

  const styles = css`
    overflow: hidden;
    transition: all 0.3s;

    &::after {
      position: absolute;
      transition: all 0.3s;
      content: "";
      width: 0;
      left: 50%;
      bottom: -5;
      background: ${skewBg};
      height: 120%;
      left: -10%;
      transform: skewX(15deg);
      z-index: -1;
    }

    &:hover {
      color: ${props.hoverFontColor ?? "#fff"};

      &::after {
        left: -10%;
        width: 120%;
      }
    }
  `;

  return <GBtn css={styles} {...rest}></GBtn>;
};

GBtnSkewFill.defaultProps = {
  skewBg: "#854DFF",
  background: "#21242C",
};

export default GBtnSkewFill;

// We need to add the below in framer
/*
addPropertyControls(Button,  {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    fontColor: {
        title: "Font Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#21242C",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    radius: {
        title: "Radius",
        type: ControlType.Number,
        defaultValue: 8,
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "Home",
    },
    ripple: {
        title: "Ripple",
        type: ControlType.Boolean,
        description: "Adds a ripple effect on click if true",
        defaultValue: true,
    },
    skewBg: {
        title: "Skew background",
        type: ControlType.Color,
        defaultValue: "#854DFF",
    },
    hoverFontColor: {
        title: "Font Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
})
*/
